import React from "react"
import { getWindow } from "ssr-window"

const window = getWindow()

export const ln2Span = (text) => {
  const formattedText = text.split('\n').map((part) => (
    <span key={part}>{part}</span>
  ))

  return formattedText
}

export const ln2Blank = ( text ) => text.replace(/\n/, '')

export const dateFormatter = dateForPreview => {
  if (typeof dateForPreview === "undefined") {
    return null
  }

  const formatted = `${dateForPreview.getFullYear()}.${(dateForPreview.getMonth() + 1).toString().padStart(2, "0")}.${(dateForPreview.getDate().toString().padStart(2, "0"))}`

  return formatted
}

export const whichBrowser = () => {
  const flags = {
    isIe: false,
    isEdge: false,
    isChrome: false,
    isSafari: false,
    isFireFox: false,
    isOpera: false,
    isUnknown: false,
  }

  if ( typeof window !== "undefined" ) {
    const userAgent = window.navigator.userAgent.toLowerCase()

    if ( userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1 ) {
      flags.isIe = true
    } else if ( userAgent.indexOf("edge") !== -1 ) {
      flags.isEdge = true
    } else if ( userAgent.indexOf("chrome") !== -1 ) {
      flags.isChrome = true
    } else if ( userAgent.indexOf("safari") !== -1 ) {
      flags.isSafari = true
    } else if ( userAgent.indexOf("firefox") !== -1 ) {
      flags.isFireFox = true
    } else if ( userAgent.indexOf("opera") !== -1 ) {
      flags.isOpera = true
    } else {
      flags.isUnknown = true
    }
  }

  return flags
}

export const whichDevice = () => {
  const flags = {
    isIPhone: false,
    isIPad: false,
    isAndroid: false,
    isPC: false,
  }

  if ( typeof window !== "undefined" ) { 
    const userAgent = window.navigator.userAgent.toLowerCase()

    if ( userAgent.indexOf("iphone") > -1 ) {
      flags.isIPhone = true
    } else if ( userAgent.indexOf("ipad") > -1 || ( userAgent.indexOf("macintosh") > -1 && "ontouchend" in document ) ) {
      flags.isIPad = true
    } else if ( userAgent.indexOf("android") > -1 ) {
      flags.isAndroid = true
    } else {
      flags.isPC = true
    }
  }

  return flags
}